import React from "react";
import { useTranslation } from "react-i18next";
import { Body1, Body2, Link } from "@activecollab/components";
import { usePrepareFileUrl } from "~/components/Hooks/usePrepareFileUrl.js";
import GenericPreviewIcon from "~/components/svg/GenericPreviewIcon.js";
import Angie from "~/utils/angie.jsx";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";

export const GenericPreview = ({ sizeValue, downloadUrl }) => {
  const { t } = useTranslation();

  const url = usePrepareFileUrl(downloadUrl);

  return (
    <ElementRoot loaded>
      <div className="ang_preview_message_wrapper">
        <div className="ang_preview_message_wrapper_inner tw-w-full tw-max-w-md">
          <GenericPreviewIcon />
          <div className="ang_preview_message">
            <Body1
              className="tw-text-theme-900 tw-mb-2"
              align="center"
            >
              {t("Preview not available")}
            </Body1>
            <Body2
              className="tw-text-theme-600"
              align="center"
            >
              {t("Preview for this file type can not be generated")}
            </Body2>
            <Body2
              className="tw-text-theme-600"
              align="center"
            >
              {t("You may wish to download the file instead")}
            </Body2>
            <Link
              href={url}
              variant="primary"
              className="btn btn--pro-2 tw-mt-7"
              download
            >
              {t("Download")} ({Angie.functions.format_file_size(sizeValue)})
            </Link>
          </div>
        </div>
      </div>
    </ElementRoot>
  );
};

GenericPreview.propTypes = mediaElementShape;

GenericPreview.defaultProps = {
  sizeValue: 0,
};
